
import { createContext, useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LoginLayout from "layouts/login"
import AccountService from "services/account";
import AppLoader from "components/app-loader";
import { Button, notification, Space, App, Modal, Spin, Input, Form } from 'antd';
import { useForm } from "antd/es/form/Form";
const accountService = new AccountService();

const AppContext = createContext();

function AppProvider({ children }) {
    const { message, notification } = App.useApp();
    const [modal, contextHolder] = Modal.useModal();
    const [loading, showLoading] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [promptProps, setPromptProps] = useState({})
    const pormptInputRef = useRef();
    const pormptOnOkRef = useRef();
    const pormptOnCancelRef = useRef();
    const [form] = useForm();
    // const [api, contextHolder] = notification.useNotification();
    const showNotify = (message) => {
        notification.info({ description: message })

    }

    const createPormpt = ({ title = "Thêm mới", label = "", value = "", onOk = () => { }, onCancel = () => { } }) => {
        setShowPrompt(true);
        // pormptInputRef.current.input.value = value;
        // pormptOnOkRef.current = onOk;
        // pormptOnCancelRef.current = onCancel;
        setPromptProps({
            title, label, onOk, onCancel
        })
        form.setFieldsValue({ value: value })
    }

    const onPromptCancel = () => {
        setShowPrompt(false);
        if (promptProps.onCancel) {
            promptProps.onCancel()
        }

    }



    const onFinish = (values) => {

        if (promptProps.onOk) {
            promptProps.onOk(values.value)
        }
        setShowPrompt(false);

    }
    const onFinishFailed = (error) => {

    }


    const printPdf = (url) => {

        // window.open(url, "_blank")

        fetch(url).then(response => {

            return response.blob().then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                print(objectURL);
                // myImage.src = objectURL;
            });


            // var blob = new Blob([res], { type: 'application/pdf' });

            // var downloadUrl = URL.createObjectURL(blob);
            // print(downloadUrl);
            // console.log(blob, downloadUrl)
            // print(downloadUrl);

            // console.log("res", res)
        })

        // var iframe = document.createElement('iframe');
        // document.body.appendChild(iframe);

        // iframe.style.display = 'none';
        // iframe.onload = function () {
        //     setTimeout(function () {
        //         iframe.focus();
        //         iframe.contentWindow.print();
        //     }, 1);
        // };


        // iframe.src = url;
    }

    const print = (url) => {
        var iframe = document.createElement('iframe');
        var childNode = document.body.appendChild(iframe);
        iframe.style.display = 'none';
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
                // setTimeout(() => {
                //     document.body.removeChild(childNode);
                // }, 5000)
            }, 1);
        };


        iframe.src = url;
    }

    async function downloadPDF(fileURL, fileName) {

        const response = await fetch(fileURL);
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);;
        // The 'download' attribute suggests the browser download the file
        // and provides a default filename.
        link.setAttribute('download', fileName || 'downloaded-file.pdf');
        link.style.display = 'none'; // Hide the link
        document.body.appendChild(link); // Append to body to make it clickable

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the DOM after the click
        document.body.removeChild(link);
    }


    async function sharePDF(fileURL, fileName) {

        const response = await fetch(fileURL);
        const blob = await response.blob();
        navigator.share({ text: "Công nợ", blob: blob })

        // const link = document.createElement('a');
        // link.href =  URL.createObjectURL(blob);;
        // // The 'download' attribute suggests the browser download the file
        // // and provides a default filename.
        // link.setAttribute('download', fileName || 'downloaded-file.pdf');
        // link.style.display = 'none'; // Hide the link
        // document.body.appendChild(link); // Append to body to make it clickable

        // // Simulate a click event to trigger the download
        // link.click();

        // // Clean up the DOM after the click
        // document.body.removeChild(link);
    }

    async function copyPDF(fileURL, fileName) {

        const response = await fetch(fileURL);
        const blob = await response.blob();
        const data = [new ClipboardItem({ "web application/pdf": blob })];
        await navigator.clipboard.write(data);
        //  navigator.share({ text: "Công nợ", blob: blob })

        // const link = document.createElement('a');
        // link.href =  URL.createObjectURL(blob);;
        // // The 'download' attribute suggests the browser download the file
        // // and provides a default filename.
        // link.setAttribute('download', fileName || 'downloaded-file.pdf');
        // link.style.display = 'none'; // Hide the link
        // document.body.appendChild(link); // Append to body to make it clickable

        // // Simulate a click event to trigger the download
        // link.click();

        // // Clean up the DOM after the click
        // document.body.removeChild(link);
    }











    return <AppContext.Provider value={{ showNotify, message, notification, modal, loading, showLoading, prompt: createPormpt, printPdf, downloadPDF, sharePDF, copyPDF }}>
        {children}
        {contextHolder}
        <Modal open={loading} maskClosable={false} closable={false} footer={false} width={100} zIndex ={9999}>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Spin tip="Loading" size="small">

                </Spin>
            </div>

        </Modal>

        <Modal title={promptProps.title} open={showPrompt} maskClosable={false} closable={true} onCancel={onPromptCancel} onOk={e => { form.submit() }} >
            <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}

            >
                <Form.Item
                    label={promptProps.label}
                    name="value"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập tên thuộc tính cha",
                        },
                    ]}
                >
                    <Input></Input>
                </Form.Item>
            </Form>
        </Modal>
    </AppContext.Provider>;
}

const useApp = () => {
    const context = useContext(AppContext);
    return context;
};

export { useApp };
export default AppProvider;
